import {useSelector} from 'react-redux';

function MasterPermission({children}) {
    const isMaster=useSelector(s=>s.user.isMaster);
    return isMaster? <>{children}</>:<></>;
}

export default MasterPermission;